export default "__VITE_ASSET__BGBzmrQ___"